import React from 'react';

const RecruitmentSources = () => {
  return <div>Recruitment Sources Page</div>;
};

export default RecruitmentSources;
